import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const init = () => {
  if (!window.SplitText) return;

  const initSplit = (selector, type, y) => {
    const els = document.querySelectorAll(selector);
    if (!els.length) return;

    els.forEach((el) => {
      /* const split = new window.SplitText(el, {
        type,
        linesClass: "line",
        wordsClass: "word",
        charsClass: "char",
      });

      const targets =
        type === "lines"
          ? split.lines
          : type === "words"
          ? split.words
          : split.chars;

      const dir = el.classList.contains("split-down") ? y : -Math.abs(y); */

      const delay = el.dataset.animdelay || 0;

      gsap.from(el, {
        // y: dir,
        scale: 1.2,
        opacity: 0,
        stagger: 0.05,
        duration: 2,
        delay: delay,
        ease: "power3.out",

        scrollTrigger: {
          trigger: el,
          // start: "top 85%",
          toggleActions: "play none none reverse",
          once: true,
        },
      });
    });
  };

  initSplit(".split-lines", "lines", 30);
  initSplit(".split-words", "words", 20);
  initSplit(".split-chars", "chars", 10);
};
